import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../../core/services/auth.service';
import { RoleRoutingService } from '../../../services/role-routing.service';
import { LoggerService } from '../../../services/logger.service';
import { TranslationService } from '../../../services/translation.service';

// Import des composants dashboard existants
import { AdminDashboardComponent } from '../../../modules/admin/pages/dashboard/admin-dashboard.component';
import { DashboardComponent as MedicalDashboardComponent } from '../../../modules/medical/pages/dashboard/dashboard.component';

@Component({
  selector: 'app-unified-dashboard',
  standalone: true,
  imports: [CommonModule, AdminDashboardComponent, MedicalDashboardComponent],
  templateUrl: './unified-dashboard.component.html',
  styleUrls: ['./unified-dashboard.component.scss'],
})
export class UnifiedDashboardComponent implements OnInit {
  private authService = inject(AuthService);
  private logger = inject(LoggerService);
  private roleRoutingService = inject(RoleRoutingService);
  public translationService = inject(TranslationService);

  ngOnInit() {
    this.logger.debug('UnifiedDashboardComponent initialized');

    // Vérifier l'authentification
    const currentUser = this.authService.currentUser();
    if (!currentUser) {
      this.logger.warn('No authenticated user found, should redirect to login');
      return;
    }

    this.logger.debug('UnifiedDashboardComponent - Current user role:', currentUser.role);
  }

  /**
   * Vérifie si l'utilisateur est un administrateur
   */
  isAdmin(): boolean {
    return this.roleRoutingService.isAdmin();
  }

  /**
   * Vérifie si l'utilisateur est un docteur ou une infirmière
   */
  isDoctorOrNurse(): boolean {
    return this.roleRoutingService.isDoctorOrNurse();
  }
}
